import gql from 'graphql-tag';

export const setGood360StatusMutation = gql`
    mutation setGood360StatusMutation($id: ID!, $status: Status360!) {
        results: good360SetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;
